<template>
  <span
    :class="['badge-pill', `badge-pill--${variant}`, `badge-pill--${size}`]"
  >
    <slot />
  </span>
</template>

<script setup lang="ts">
interface Props {
  variant?: "filled" | "outlined";
  size?: "sm" | "md" | "lg";
}

withDefaults(defineProps<Props>(), {
  variant: "filled",
  size: "md",
});
</script>

<style scoped>
.badge-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  font-family: var(--font-family-body);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
  border-radius: 0.5em;
  text-align: center;
}

/* Variants */
.badge-pill--filled {
  background: var(--color-text-base);
  color: var(--color-text-inverted);
}

.badge-pill--outlined {
  background: transparent;
  color: var(--color-text-base);
  border: 2px solid currentColor;
}

/* Sizes */
.badge-pill--sm {
  padding: 0.35em 0.75em;
  font-size: var(--font-size-xs);
}

.badge-pill--md {
  padding: 0.5em 1em;
  font-size: var(--font-size-sm);
}

.badge-pill--lg {
  padding: 0.65em 1.25em;
  font-size: var(--font-size-base);
}
</style>
